const paramMatcher = /(?<name>[a-zA-Z0-9-]+)-version/;
/**
 * Tries to determine the environment based on the hostname and query parameters.
 */
export const getEnvironment = (href) => {
    const url = new URL(href);
    const { hostname, searchParams } = url;
    /**
     * If any query parameter matches a federated version override, say that we're in
     * development mode.
     */
    for (const key of searchParams.keys()) {
        if (paramMatcher.test(key)) {
            return "development";
        }
    }
    if (hostname.startsWith("localhost") || hostname.startsWith("localdev.")) {
        return "development";
    }
    else if (hostname.startsWith("cloud.s2r1.")) {
        return "staging";
    }
    else if (hostname.startsWith("cloud.")) {
        return "production";
    }
    else {
        return "unknown";
    }
};
